export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/intros_outros.3533d2e.svg";